export default __webpack_public_path__ + "static/statrys-devices-fcd7da61b564ce50158fcc6123f4398e.png";